"use strict";

$(function(){
    if($('.random').length){
        var bool = [1, -1];
        $('.random').html(
        $('.random>*').sort(function (a, b) {
            return bool[Math.floor(Math.random() * bool.length)];
        })
        );
    }
	$("a[href^='#']").click(function(){
		var speed = 600;
		var href= $(this).attr("href");
		var target = $(href === "#" || href === "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
});


/* ----------- accordion ------------------- */
$('.accordionBtn dt').on("click", function () {
	$(this).next('.accordionBtn dd').slideToggle(200);
	$(this).next('.accordionBtn dd').toggleClass("open");
	$(this).toggleClass("open");
});

//modal

let winClose = ()=>{	
	$(".modalWrap, .modal_backgronud").removeClass("isShow");
}


$(function () {
	$(".modal_btn01").on("click", function () {
		winClose();
		$("#modal01, .modal_backgronud01").addClass("isShow");
	});
	$(".modal_dismiss01, .modal_backgronud01").on("click", function () {
		$("#modal01, .modal_backgronud01").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn02").on("click", function () {
		winClose();
		$("#modal02, .modal_backgronud02").addClass("isShow");
	});
	$(".modal_dismiss02, .modal_backgronud02").on("click", function () {
		$("#modal02, .modal_backgronud02").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn03").on("click", function () {
		winClose();
		$("#modal03, .modal_backgronud03").addClass("isShow");
	});
	$(".modal_dismiss03, .modal_backgronud03").on("click", function () {
		$("#modal03, .modal_backgronud03").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn04").on("click", function () {
		winClose();
		$("#modal04, .modal_backgronud04").addClass("isShow");
	});
	$(".modal_dismiss04, .modal_backgronud04").on("click", function () {
		$("#modal04, .modal_backgronud04").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn05").on("click", function () {
		winClose();
		$("#modal05, .modal_backgronud05").addClass("isShow");
	});
	$(".modal_dismiss05, .modal_backgronud05").on("click", function () {
		$("#modal05, .modal_backgronud05").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn06").on("click", function () {
		winClose();
		$("#modal06, .modal_backgronud06").addClass("isShow");
	});
	$(".modal_dismiss06, .modal_backgronud06").on("click", function () {
		$("#modal06, .modal_backgronud06").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn07").on("click", function () {
		winClose();
		$("#modal07, .modal_backgronud07").addClass("isShow");
	});
	$(".modal_dismiss07, .modal_backgronud07").on("click", function () {
		$("#modal07, .modal_backgronud07").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn08").on("click", function () {
		winClose();
		$("#modal08, .modal_backgronud08").addClass("isShow");
	});
	$(".modal_dismiss08, .modal_backgronud08").on("click", function () {
		$("#modal08, .modal_backgronud08").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn09").on("click", function () {
		winClose();
		$("#modal09, .modal_backgronud09").addClass("isShow");
	});
	$(".modal_dismiss09, .modal_backgronud09").on("click", function () {
		$("#modal09, .modal_backgronud09").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn10").on("click", function () {
		winClose();
		$("#modal10, .modal_backgronud10").addClass("isShow");
	});
	$(".modal_dismiss10, .modal_backgronud10").on("click", function () {
		$("#modal10, .modal_backgronud10").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn11").on("click", function () {
		winClose();
		$("#modal11, .modal_backgronud11").addClass("isShow");
	});
	$(".modal_dismiss11, .modal_backgronud11").on("click", function () {
		$("#modal11, .modal_backgronud11").removeClass("isShow");
	});
});

$(function () {
	$(".modal_btn12").on("click", function () {
		winClose();
		$("#modal12, .modal_backgronud12").addClass("isShow");
	});
	$(".modal_dismiss12, .modal_backgronud12").on("click", function () {
		$("#modal12, .modal_backgronud12").removeClass("isShow");
	});
});

